import { Injectable } from '@angular/core';
import {PconsDialogComponent} from './pcons-dialog.component';
import {PeerConnectionApiService} from '../../../services/api/peer-connection/peer-connection-api.service';
import {MatDialog} from '@angular/material/dialog';
import {SnackBarService} from '../../../services/common/snack-bar/snack-bar.service';
import {ConfirmationDialogComponent} from '../../../dialogs/confirmation-dialog/confirmation-dialog.component';
import * as _ from 'lodash';

@Injectable({
  providedIn: 'root'
})
export class PconsDialogService {

  constructor(private peerConnectionApiService: PeerConnectionApiService,
              private snackBarService: SnackBarService,
              public dialog: MatDialog) { }

  editPCon(selection, voipPeers, attrManipulation, callsQuotas,
           cacProfiles, sipReasonGroups, advancedConditions, shortCallsProfilesOptions, onSuccess = () => {}, onFailure = () => {}): void {
    this.peerConnectionApiService.getPcon(selection.id).then(pCon => {

      const dialogRef = this.dialog.open(PconsDialogComponent, {
        data: {
          selectedItem: _.cloneDeep(pCon),
          voipPeers,
          attrManipulation,
          callsQuotas,
          cacProfiles,
          sipReasonGroups,
          advancedConditions,
          shortCallsProfilesOptions
        }
      });

      dialogRef.componentInstance.onApply.subscribe(result => {
        this.peerConnectionApiService.editPCon(result.selectedItem, selection.id).then(() => {
          dialogRef.close();
          this.snackBarService.display(`"${result.selectedItem.name}" successfully edited`);
          onSuccess();
        });
      });
    });
  }

  remove(selection, onSuccess = () => {}): void {
    const confirmationMessage = `Are you sure you want to delete the peer connection: "${selection.name}"?`;

    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      data: {
        message: confirmationMessage
      }
    });

    dialogRef.componentInstance.onApply.subscribe(() => {
      this.peerConnectionApiService.deletePCon(selection.id).then(() => {
        dialogRef.close();
        this.snackBarService.display(`"${selection.name}" successfully deleted`);
        onSuccess();
      });
    });
  }
}
